export default "__VITE_ASSET__BGWJ0Ddo__"